export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;
export const SESSION_ID_DATA_LAYER_KEY = 'fsSession';
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL ?? '';
export const DROPDOWN_QUESTION_TYPE = 'dropdown';
export const GP_SEARCH_QUESTION_NAME = 'GP Search';
export const GOOGLE_PLACES_API = process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY ?? '';
export const NEWRELIC_APP_ID = process.env.NEXT_PUBLIC_NEWRELIC_APP_ID ?? '';
export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID ?? '';
export const GTM_PREVIEW_ID = process.env.NEXT_PUBLIC_GTM_PREVIEW_ID ?? '';
export const GTM_AUTH_KEY = process.env.NEXT_PUBLIC_GTM_AUTH_KEY ?? '';
export const GROWTHBOOK_CLIENT_KEY = process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY ?? '';
export const GROWTHBOOK_DECRYPTION_KEY = process.env.NEXT_PUBLIC_GROWTHBOOK_DECRYPTION_KEY ?? '';
export const BMI_FIRST_SURVEY_ID = '4907491'
export const PRESCRIPTION_UPLOAD_SURVEY_ID = '1300247'
export const DIGA_SURVEY_ID = '4656854'
export const isProduction = process.env.NODE_ENV === 'production';
export const RECAPTCHA_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? '';
export const TRUSTPILOT_BUSINESS_UNIT_ID = process.env.NEXT_PUBLIC_TRUSTPILOT_BUSINESS_UNIT_ID ?? '';
